/**
 * /tenants/$slug/onboarding-health — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchOnboardingHealth } from "@/features/onboarding-health/queries";
import { queryKeys } from "@/lib/query-keys";
import { OnboardingHealthPage } from "@/features/onboarding-health/pages/onboarding-health-page";

export const Route = createFileRoute(
  "/_authed/tenants/$slug/onboarding-health/",
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.onboardingHealth(context.tenant.id),
      queryFn: () => fetchOnboardingHealth(context.tenant.id),
    }),
  component: OnboardingHealthPage,
});
